import React from 'react';
import { DraggableProvidedDragHandleProps } from '@hello-pangea/dnd';
import { Widget } from '../../pages/dashboard/Dashboard';
import { usePluginContext } from '../plugin/PluginContext';
import { DashboardPlugin, DashboardPluginProps, ReportingPlugin } from '../plugin/PluginType';
import './WidgetComponent.scss';
import WidgetCard from '../../components/WidgetCard';

interface WidgetComponentProps {
    widget: Widget;
    plugin?: DashboardPlugin | ReportingPlugin;
    /** Provided by the parent Draggable render-prop — null when pinned */
    dragHandleProps?: DraggableProvidedDragHandleProps | null;
    isPinned?: boolean;
    onUpdateWidget: (widgetId: string, updates: Partial<Widget>) => void;
    onRemoveWidget: (widgetId: string) => void;
}

const WidgetComponent: React.FC<WidgetComponentProps> = ({
                                                             widget,
                                                             plugin,
                                                             dragHandleProps,
                                                             isPinned = false,
                                                             onUpdateWidget,
                                                             onRemoveWidget,
                                                         }) => {
    const pluginContext = usePluginContext();

    // ── Plugin not found ──────────────────────────────────────
    if (!plugin) {
        return (
            <div className="widget-card">
                <div className="widget-card__header">
                    <span className="widget-card__title">Widget-Fehler</span>
                    <div className="widget-card__actions">
                        <button
                            className="widget-card__remove-btn"
                            onClick={() => onRemoveWidget(widget.id)}
                            aria-label="Fehlerhaftes Widget entfernen"
                        >
                            ×
                        </button>
                    </div>
                </div>
                <div className="widget-card__body">
                    <p style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                        Plugin nicht gefunden: {widget.pluginId}
                    </p>
                </div>
            </div>
        );
    }

    const pluginProps: DashboardPluginProps = {
        context: pluginContext,
        widgetId: widget.id,
        size: widget.size,
        preferences: widget.preferences,
    };

    return (
        <WidgetCard
            title={widget.title}
            icon={widget.icon}
            requiredPermissions={plugin.requiredPermissions}
            dragHandleProps={dragHandleProps}
            isPinned={isPinned}
            onRemove={() => onRemoveWidget(widget.id)}
        >
            {'component' in plugin && plugin.component && (
                <plugin.component
                    context={pluginContext}
                    widgetId={widget.id}
                    size={widget.size}
                    preferences={widget.preferences}
                />
            )}
        </WidgetCard>
    );
};

export default WidgetComponent;